/** Typed confirmation word the BE requires on hold and approval rollback. */
export const CONFIRM_WORD = 'CONFIRM';
